import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { compose } from 'recompose'

import {
  AJEventParticipantTable
} from 'components/sections/adventurous-journeys'
import { AjEventAddParticipant } from 'containers/forms/aj-events'
import { meta } from 'helpers/decorators'
import { modal } from 'redux/modules/app'
import { apiAjEvents } from 'helpers/decorators/api'
import { AJ_PROGRESS_STATES } from 'constants/enums'

const enhance = compose(
  meta({
    title: 'Event participants',
    noOverride: true
  }),
  connect(null, { modal }),
  apiAjEvents({
    detail: true,
    updateAjEventDetail: true
  })
)

class AjEventParticipants extends Component {
  static propTypes = {
    ajEvents: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    approveAjEventParticipant: PropTypes.func.isRequired,
    returnAjEventParticipant: PropTypes.func.isRequired
  }
  render() {
    const {
      ajEvents: { loading, detail },
      approveAjEventParticipant,
      returnAjEventParticipant
    } = this.props

    const disableManagingParticipants = get(
      detail,
      'ajParticipantEvents',
      []
    ).some(
      item =>
        get(item, 'state.value') === AJ_PROGRESS_STATES.ajSetup.id ||
        get(item, 'state.value') === AJ_PROGRESS_STATES.ajApproval.id
    )

    return (
      <div>
        <AjEventAddParticipant
          disableManagingParticipants={disableManagingParticipants}
        />
        <AJEventParticipantTable
          list={detail.ajParticipantEvents}
          ajEvent={detail}
          loading={loading}
          approveAjEventParticipant={approveAjEventParticipant}
          returnAjEventParticipant={returnAjEventParticipant}
          modal={this.props.modal}
        />
      </div>
    )
  }
}

export default enhance(AjEventParticipants)
